import { ListChecks } from "lucide-react";
import BlockList from "../BlockList";

/**
 * Master v5 Prompt 9 — Checklist renderer. Block-based (block_type
 * "checklist"), reusing the exact accepted WorkDocument engine for
 * leasing/autosave/versioning — only RoomBlockField's checkbox widget
 * differs from a plain textarea.
 */
export default function ChecklistRenderer({ workspaceId, docId, instructions, isViewAsClient, isInstanceLocked }) {
  return (
    <div data-testid="renderer-checklist">
      <div className="flex items-center gap-2 text-ink-soft mb-3">
        <ListChecks size={16} /><span className="text-sm uppercase tracking-wide">Checklist</span>
      </div>
      {instructions && <p className="text-ink-soft text-sm mb-4" data-testid="renderer-checklist-instructions">{instructions}</p>}
      <BlockList workspaceId={workspaceId} docId={docId} isViewAsClient={isViewAsClient} isInstanceLocked={isInstanceLocked} />
    </div>
  );
}
